import axios from "axios";

const urlPath = "stockKae";


export const getAllStockKae = async () => {
  try {
    const response = await axios.get(urlPath);
    return response.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const getStockKae = async (id) => {
  try {
    const response = await axios.get(`${urlPath}/${id}`);
    return response.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const createStockKae = async (data) => {
    console.log("createStockKae data:", data)
  try {
    const response = await axios.post(urlPath, {
      producto_id: data.producto_id,
      almacen_id: data.almacen_id,
      cantidad: data.cantidad,
      stock_minimo: data.stock_minimo,
      stock_maximo: data.stock_maximo,
    });
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const updateStockKae = async (data) => {
    console.log(data)
  try {
    const response = await axios.put(`${urlPath}`, {
      producto_id: data.producto_id,
      cantidad: data.cantidad,
      almacen_id: data.almacen_id,
      stock_minimo: data.stock_minimo,
      stock_maximo: data.stock_maximo,
    });
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const transferirStockKae = async (data) => {
  try {
    const response = await axios.post(`${urlPath}/transferir`, data);
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const getEstadisticasKae = async () => {
  try {
    const response = await axios.get(`${urlPath}/estadisticas`);
    return response.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const deleteStockKae = async (id) => {
  try {
    const response = await axios.delete(`${urlPath}/${id}`);
    return response.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};
